<template>
  <div class="modal-drag-custom-drag" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="$store.commit('contracts/setContractSignModal', null)"
			:focusTrap="true"
			:adaptive="true"
			height="auto"

		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
            <div class="d-flex flex-row flex-grow-1 align-center justify-space-between py-2 px-8">
							<div class="d-flex flex-row align-center justify-start">
								<v-icon color="#959595" class="mr-2">mdi-file-pdf-box</v-icon>
								<p class="mb-0 font-weight-bold text-primary body-1" v-if="contract.addendum_to_contract_id">Firmar Anexo de Contrato</p>
								<p class="mb-0 font-weight-bold text-primary body-1" v-else>Firmar Contrato</p>
							</div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										small
										color="#959595"
										@click="$store.commit('contracts/setContractSignModal', null)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark>mdi-close</v-icon>
									</v-btn>
								</template>
								<span>Cerrar</span>
							</v-tooltip>
						</div>
				</v-card-title>
				<v-card-text class="py-2 px-8">
					<p>¿Deseas firmar el {{contract.addendum_to_contract_id ? 'anexo':'contrato'}} del proyecto <b>{{contract.morphable?.name}}</b>?</p>
					<div v-if="!this.contract.companySign && this.isClient">
						<p class="mb-3 caption font-weight-bold">Antes de continuar por favor selecciona una fecha de inicio para tu {{contract.addendum_to_contract_id ? 'anexo':'contrato'}}</p>
						<div class="mb-4 mr-4">
							<v-menu
								ref="startDateMenu"
								v-model="startDateMenu"
								:close-on-content-click="false"
								transition="scale-transition"
								offset-y
								min-width="auto"
								max-width="250"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:value="selectedStartDate | toDate"
										label="Fecha Inicio"
										prepend-icon="mdi-calendar"
										readonly
										dense
										class="custom-height-search custom-height-calendar"
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="selectedStartDate"
									no-title
									scrollable
									:first-day-of-week="1"
									locale="es-cl"
									for
									:events="startDateSelectionOptions?.holidays"
									:allowed-dates="allowedDates"
									:max-date="startDateSelectionOptions?.max_date"
									:min-date="startDateSelectionOptions?.min_date"
									:picker-date.sync="pickerDate"
									width="100%"
									reactive
									dense
									event-color="red lighten-1"
									color="green"
									class="custom-calendar-sidemini pb-4"
									@change="changeContratDate"
								>
									<v-spacer></v-spacer>
									<v-btn
										text
										color="#524D4D"
										@click="startDateMenu = false"
									>
										Cancelar
									</v-btn>
									<v-btn
										text
										color="#524D4D"
										@click="$refs.startDateMenu.save(selectedStartDate)"
									>
										Confirmar
									</v-btn>
								</v-date-picker>
							</v-menu>
						</div>
					</div>
        </v-card-text>
        <v-card-actions class="pa-0">
					<div class="d-flex flex-grow-1 justify-end py-2 px-8">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="green"
									class="mb-0"
									small
									:dark="!isDisabledSignButton"
									:disabled="isDisabledSignButton"
									v-bind="attrs"
									v-on="on"
									@click="startSignContract"
								>
									<v-icon small>mdi-signature-freehand</v-icon>
									<div v-if="contract.addendum_to_contract_id">
										<p class="mb-0 ml-2 caption" v-if="contract.companySign">Firmar el Anexo como Representante Legal</p>
										<p class="mb-0 ml-2 caption" v-else>Firmar el Anexo de Contrato</p>
									</div>
									<div v-else>
										<p class="mb-0 ml-2 caption" v-if="contract.companySign">Firmar el Contrato como Representante Legal</p>
										<p class="mb-0 ml-2 caption" v-else>Firmar el Contrato</p>
									</div>
								</v-btn>
							</template>
							<span>{{ signButtonDescription }}</span>
						</v-tooltip>
					</div>
				</v-card-actions>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { getContract, signContract, companySignContract, updateContract } from '@/helpers/api/contracts'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

export default {
  name: 'ContractSignModal',
  data: () => ({
		indexModal: + new Date(),
		startDateMenu: false,
		selectedStartDate: null,
		pickerDate: null,
		local_contract: null
  }),
  computed: {
		userInfo(){
			return this.$store.state.user.userInfo
		},	
		isSubcontract(){
			return !!this.contract.subcontract_to_contract_id
		},
		isContractor(){
			if(!this.isSubcontract) return false
			return this.userInfo.id == this.contract.contractor?.id
		},
		isClient(){
			return this.userInfo.id == this.contract.morphable?.client_id
		},
		isDisabledSignButton(){
			if(this.isContractor || this.contract.companySign) return false
			console.log('this.contract.start_date', this.contract.start_date)
			return !this.contract.start_date
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		startDateSelectionOptions(){
			return this.$store.state.contracts.contractSignModal?.start_date_selection_options
		},
		signButtonDescription(){
			const type = this.contract.addendum_to_contract_id ? 'anexo contrato' : 'contrato'

			if(this.contract.companySign){
				return `Firmarás el ${type} como representante legal y se notificará al cliente`
			}
			return `Se firmará el ${type} y se informará a la empresa para que esta termine el proceso`
		},
		modalSignStatus(){
			return !!this.$store.state.contracts.contractSignModal
		},
		contract(){
			return this.local_contract || this.$store.state.contracts.contractSignModal
		}
	},
	watch: {
		startDateSelectionOptions(newValue){
			if(newValue){
				this.pickerDate = newValue.min_date
				const c_date = this.contract.start_date ? this.contract.start_date : this.startDateSelectionOptions.min_date
				this.selectedStartDate = this.$options.filters.toDate(c_date, null, 'YYYY-MM-DD')
			}
		},
	},
  mounted(){
		if(this.contract.start_date){
			this.selectedStartDate = this.$options.filters.toDate(this.contract.start_date, null, 'YYYY-MM-DD')
		}
		else if(this.startDateSelectionOptions){
			this.pickerDate = this.startDateSelectionOptions.min_date
			if(this.startDateSelectionOptions && this.startDateSelectionOptions.min_date){
				this.selectedStartDate = this.$options.filters.toDate(this.startDateSelectionOptions.min_date, null, 'YYYY-MM-DD')
			}
		}
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		this.getContractInfo()
  },
  methods: {
		setStartDate(){
			if(!this.contract.start_date && this.selectedStartDate) {
				this.$nextTick(() => {
					this.changeContratDate(this.selectedStartDate)
				})
			}
		},
		allowedDates(date){
			return this.startDateSelectionOptions?.starting_day_allowed.includes(date)
		},
		async startSignContract(){
			if(!this.selectedStartDate && !this.contract.companySign){
				const messageData = {
					message: 'Por favor primero selecciona una fecha de inicio del proyecto.',
					title: 'Fecha no Seleccionada',
					type: 'warning',
					icon: 'mdi-alert-outline',
					color: 'orange',
				}
				this.setMessage(messageData)
				return null
			}
			if(!this.$store.state.user.userInfo?.signature){
				this.$store.commit('users/setUserSignatureModal', true)
				let tipo = this.contract.addendum_to_contract_id ? 'anexo contrato' : 'contrato';
				let messageData = {
					message: `Debes definir tu firma simple antes de firmar el ${tipo}.`,
					title: 'Firma no definida',
					type: 'warning',
					icon: 'mdi-information',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				if(this.contract.companySign){
					this.signAsCompany()
				}
				else{
					this.signAsClient()
				}
			}
		},
		async changeContratDate(date){
			this.selectedStartDate = date
			if(!this.selectedStartDate){
				const messageData = {
					message: 'Por favor primero selecciona una fecha.',
					title: 'Fecha no Seleccionada',
					type: 'warning',
					icon: 'mdi-alert-outline',
					color: 'orange',
				}
				this.setMessage(messageData)
				return null
			}
			const data = {
				contract_id: this.contract.id,
				start_date: this.selectedStartDate,
				get_model: true
			}
			const update_contract = await updateContract(data)
			if(update_contract.code == 200){
				this.getContractInfo()
			}
			// this.$refs.startDateMenu.save(this.selectedStartDate)
		},
		async getContractInfo(){
			if(this.contract.id){
				const contract = await getContract({contract_id: this.contract.id})
				if(contract.code == 200){
					this.local_contract = {...this.contract, ...contract.contract}
					if(!this.local_contract?.start_date){
						this.setStartDate()
					}
				}
			}
		},
		async signAsClient(){
			const signed = await signContract({contract_id: this.contract.id})
			if(signed.code == 200){
				eventBus.$emit('reloadInformation', {contract_id: this.contract.id})
				let tipo = this.contract.addendum_to_contract_id ? 'anexo contrato' : 'contrato';
				let messageData = {
					message: `¡Genial! Tu ${tipo} ha sido firmado correctamente.`,
					title: `${tipo.charAt(0).toUpperCase() + tipo.slice(1)} Firmado`,
					type: 'warning',
					icon: 'mdi-information',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
				setTimeout(() => {
					window.open(signed.url)
				}, 1000)
			}
			this.$store.commit('contracts/setContractSignModal', null)
		},
		async signAsCompany(){
			try {
				const sign = await companySignContract({contract_id: this.contract.id})
				if(sign.code == 200){
					eventBus.$emit('reloadInformation', {contract_id: this.contract.id})
					const tipo = this.contract.addendum_to_contract_id ? 'anexo contrato' : 'contrato';
					const messageData = {
						message: `Se ha firmado correctamente el ${tipo}. Se ha notificado al cliente.`,
						title: `${tipo.charAt(0).toUpperCase() + tipo.slice(1)} Firmado`,
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.setMessage(messageData)
					this.$store.commit('contracts/setContractSignModal', null)
				}
			} catch (error) {
				if(error.data){
					error.data.forEach(message => {
						const messageData = {
							message: message.message,
							title: 'Error',
							type: 'danger',
							icon: 'mdi-close-octagon',
							color: '#FF1209',
						}
						this.setMessage(messageData)
					})
				}
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>